module.exports = __SPARKY_LIBS__.ReactJsxRuntime;